import React from 'react';
import cn from '../../lib/cn';
import useParallax from '../../hooks/useParallax';

/**
 * Drifts its children as they cross the viewport. Give the parent
 * `overflow-hidden` when using `scale`, so the zoom stays inside its frame.
 */
export function Parallax({
  as: Tag = 'div',
  children,
  speed = 40,
  scale = 0,
  axis = 'y',
  className,
  ...rest
}) {
  const ref = useParallax({ speed, scale, axis });

  return (
    <Tag ref={ref} className={cn(className)} {...rest}>
      {children}
    </Tag>
  );
}

export default Parallax;
